import { AsCache, WithOwner } from "../IDBSchema";
import { EntityDataApi } from "../IndexedDBApi";
import { GroupBase } from "../../../schema/generated/Group";
import { getFromIdPayload } from "../../../schema/general";
import { idbEntityDefs } from "../generated/entityDefs";
import { required } from "../../../util/typed";

export class GroupDataApi extends EntityDataApi<GroupBase> {
  public readonly def = idbEntityDefs.Group;

  // 現行挙動を維持するため、Groupは論理削除を考慮せず返す
  public async getAll(ownerId: string): Promise<GroupBase[]> {
    return await this.listByOwner(ownerId, false);
  }

  public async getById(payload: WithOwner<getFromIdPayload>): Promise<GroupBase> {
    const data = await this.readByKey(payload.id, payload.ownerId);
    return required(data, "グループ");
  }

  public async cache(payload: AsCache<WithOwner<GroupBase>>) {
    await this.writeRow(payload);
    return { status: "ok" };
  }
}
